/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LeaseInputs */

const cs_enum_lease = /** @type {(inputs: Enum_LeaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nájemní smlouva`)
};

const en_enum_lease = /** @type {(inputs: Enum_LeaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lease`)
};

/**
* | output |
* | --- |
* | "Lease" |
*
* @param {Enum_LeaseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_lease = /** @type {((inputs?: Enum_LeaseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LeaseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_lease(inputs)
	return cs_enum_lease(inputs)
});